import { jsx as _jsx } from "react/jsx-runtime";
import React, { useMemo } from 'react';
import { getTestIds } from 'seagull/utils/TestIds';
import { useLocaleKeys } from '~/i18n';
import { StringMatchChip } from '../StringMatchChip/StringMatchChip';
export const GetContactNameChipTID = (parentTestId)=>getTestIds(parentTestId);
export const ContactNameChip = (param)=>{
    let { testId, predicate, onChange } = param;
    const { ContactNameChipTestIds } = useMemo(()=>GetContactNameChipTID(testId), [
        testId
    ]);
    const { t } = useLocaleKeys('pages.draftsDashboard.aiSearch');
    return /*#__PURE__*/ _jsx(StringMatchChip, {
        testId: testId,
        predicate: predicate,
        onChange: onChange,
        labels: {
            contains: (value)=>t.recipientNameContains({
                    value
                }),
            fuzzy: (value)=>t.recipientNameFuzzy({
                    value
                }),
            exact: (value)=>t.recipientNameExact({
                    value
                }),
            startsWith: (value)=>t.recipientNameStartsWith({
                    value
                }),
            empty: ()=>t.recipientNameLabel()
        },
        biNames: {
            edit: 'drafts_ai_search_chip_edit_contact_name',
            apply: 'drafts_ai_search_chip_apply_contact_name',
            remove: 'drafts_ai_search_chip_remove_contact_name'
        },
        popoverTestIds: {
            EditPopover: ContactNameChipTestIds.EditPopover(),
            EditTextField: ContactNameChipTestIds.EditTextField(),
            ApplyButton: ContactNameChipTestIds.ApplyButton()
        }
    });
};
